export type { HeadlineTextProps } from './HeadlineText'
export { HeadlineText } from './HeadlineText'
